<template>
  <div>
    <!-- 列表开始 -->
    <div class="BlockList">
      <div class="BlockList-W">
        <div class="ownersuccess">
          <div class="successtit">Verify Address Ownership</div>
          <div class="successtit1">
            Find out more about <router-link to="/m/instructions" target="_blank" ><span>Verify Address Ownership</span></router-link>
          </div>
          <div class="successbox">
            <div class="boxtit">
              <img src="../../../assets/pc/Logo/error.png" />
              <div class="tit">
                Sorry, the ownership verification for address
              </div>
            </div>
            <div class="boxtit1">
              [{{ contractAddress }}] did not pass. Please
              check if your signature information is correct.
            </div>
          </div>
          <div class="black" @click="goback">
            Back <img src="../../../assets/pc/Logo/left.png" />
          </div>
        </div>
      </div>
    </div>
    <!-- 列表结束 -->
  </div>
</template>

<script>
import { GetBlockList } from "@/assets/server/api";
export default {
  data() {
    return {
      flag: false,
      flag1: true,
      contractAddress:"",
    };
  },
  components: {},
  created() {},
  mounted() {
    // this.BlockList();
  },
  watch: {
    $route: {
      handler: function (to, form) {
        if (to.path === "/m/Ownererror") {
          this.contractAddress = to.query.contractAddress;
         

          //  console.log(this.contractAddress);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    search() {},
    goback(){
      this.$router.push("/m/Ownership");
    }
  },
};
</script>

<style lang="less" scoped>
.BlockList {
  width: 100%;

  background: #13161b;
  height: 100%;
  overflow: auto;
  .BlockList-W {
    width: 630px;
    margin: 0 auto;
    height: 800px;
    background: #13161b;
    padding-bottom: 36px;
    position: relative;

    .ownersuccess {
      width: 630px;
      height: 459px;
      background: #000000;
      border-radius: 20px 20px 20px 20px;
      opacity: 1;
      position: absolute;
      // border: 1px solid red;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      .successtit {
        margin-top: 40px;
        text-align: center;
        height: 42px;
        font-size: 36px;
        font-family: Roboto, Roboto;
        font-weight: 500;
        color: #ffffff;
        line-height: 42px;
      }
      .successtit1 {
        margin-top: 12px;
        height: 28px;
        font-size: 24px;
        font-family: Roboto, Roboto;
        font-weight: 400;
        color: #ffffff;
        line-height: 28px;
        text-align: center;
        span {
          color: #00e79a;
          cursor: pointer;
        }
      }
      .successbox {
        width: 550px;
        height: 199px;
        background: #13161b;
        border-radius: 12px 12px 12px 12px;
        opacity: 1;
        margin: 0 auto;
        margin-top: 30px;
        .boxtit {
          display: flex;
          padding-top: 19px;
          img {
            width: 27px;
            height: 27px;
            margin-left: 21px;
          }
          .tit {
            width: 475px;
            height: 60px;
            font-size: 26px;
            font-family: Roboto, Roboto;
            font-weight: 400;
            color: #ff4964;
            line-height: 30px;
            margin-left: 8px;
          }
        }
        .boxtit1 {
          width: 510px;
          height: 90px;
          font-size: 26px;
          font-family: Roboto, Roboto;
          font-weight: 400;
          color: #ffffff;
          line-height: 30px;
          word-spacing: -2px;
          margin-top: 13px;
          margin-left: 21px;
          word-break: break-all;
        }
      }
      .black {
        text-align: center;
        height: 21px;
        font-size: 24px;
        font-family: Roboto, Roboto;
        font-weight: 400;
        color: #ffffff;
        line-height: 21px;
        margin-top: 41px;
        cursor: pointer;
        img {
          width: 32px;
          height: 32px;
          margin-left: 2px;
          margin-top: -2px;
        }
      }
    }
  }
}
</style>
